import { InquiryButtonLink as ButtonLink } from "./inquiry-origin.js";
import { InquiryLink as Link } from "./inquiry-origin.js";
import { ArrowRight } from "lucide-react";
import { type ReactNode } from "react";

import { Eyebrow } from "@zylarity/ui";
import { recordPublicExclusiveAccess } from "./public-site-activity.js";

export function InteriorHero({
  eyebrow,
  title,
  copy,
  visual,
  note,
  supportingContent,
  children,
  className = "",
}: {
  eyebrow: string;
  title: string;
  copy: string;
  visual?: ReactNode;
  note?: string;
  supportingContent?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={`interior-hero public-shell ${visual ? "interior-hero--with-visual" : "interior-hero--text-only"} ${className}`}
    >
      <div>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1>{title}</h1>
        <p>{copy}</p>
        {note && <p className="report-page-hero__note">{note}</p>}
        {supportingContent}
        {children && <div className="interior-hero__actions">{children}</div>}
      </div>
      {visual && <aside>{visual}</aside>}
    </section>
  );
}

export function CapabilityCards({ items }: { items: readonly (readonly [string, string])[] }) {
  return (
    <section className="public-shell talent-capabilities talent-capabilities--page">
      {items.map(([title, copy]) => (
        <article key={title}>
          <h2>{title}</h2>
          <p>{copy}</p>
        </article>
      ))}
    </section>
  );
}

export function IntakeInvitation({ kind }: { kind: "CANDIDATE" | "CLIENT" }) {
  const candidate = kind === "CANDIDATE";
  const exclusiveAccessClick = candidate
    ? { onClick: () => recordPublicExclusiveAccess("PROFESSIONALS_PAGE") }
    : {};
  return (
    <section className="public-shell intake-invitation">
      <div>
        {candidate && <p className="intake-eyebrow">Start when you are ready</p>}
        <h2>{candidate ? "Go beyond the job board." : "Ready to share more about the role?"}</h2>
        <p>
          {candidate
            ? "Be considered for relevant OT opportunities before they reach our public job board."
            : "Tell us about a planned hire or add details for your open roles. We’ll ask you to verify your email first."}
        </p>
      </div>
      <div className="intake-invitation__actions">
        <ButtonLink
          href={candidate ? "/intake/candidate?interest=early-access" : "/intake/client"}
          {...exclusiveAccessClick}
        >
          {candidate ? "Get Exclusive Access" : "Share hiring details"}
        </ButtonLink>
        {!candidate && (
          <Link className="text-link" to="#employer-inquiry">
            Ask a question first <ArrowRight size={16} aria-hidden="true" />
          </Link>
        )}
      </div>
    </section>
  );
}

export function FinalCta() {
  return (
    <section className="final-cta public-shell">
      <div>
        <Eyebrow>A useful next conversation</Eyebrow>
        <h2>Find the expertise your team needs.</h2>
      </div>
      <ButtonLink href="/contact?kind=EMPLOYER" via="closing-call-to-action">
        Discuss Your Needs
      </ButtonLink>
    </section>
  );
}
